/**
 * property action
 *
 */
import {
    PROPERTY_GET_PROPERTIES,
    PROPERTY_GET_SELECTED_PROPERTY,
    PROPERTY_UPDATE_PROPERTY,
    PROPERTY_CHANGE_FIELD,
    PROPERTY_DELETE_PROPERTY,
    PROPERTY_SEND_FILE
} from './types'
export const propertyChangeField = (name, value) => {
    return {
        type: PROPERTY_CHANGE_FIELD,
        name,
        value
    }
}
export const propertyGetProperties = (pageNumber = 1, entriesPerPage = 10) => {
    return {
        type: PROPERTY_GET_PROPERTIES,
        payload: {
            request: {
                method: 'GET',
                url: `/properties?pageNumber=${pageNumber}&entriesPerPage=${entriesPerPage}`,
            }
        }
    }
}
export const propertyGetSelectedProperty = (property) => {
    return {
        type: PROPERTY_GET_SELECTED_PROPERTY,
        property
    }
}
export const propertyDeleteProperty = id => {
    return {
        type: PROPERTY_DELETE_PROPERTY,
        payload: {
            request: {
                method: 'DELETE',
                url: `/properties/${id}`,
            }
        }
    }
}
export const propertyUpdateProperty = (id, data) => {
    return {
        type: PROPERTY_UPDATE_PROPERTY,
        payload: {
            request: {
                method: 'PATCH',
                url: `/properties/${id}`,
                data
            }
        }
    }
}
export const propertySendFile = (id, data) => {
    return {
        type: PROPERTY_SEND_FILE,
        payload: {
            request: {
                method: 'POST',
                url: `/files/residence/${id}`,
                data
            }
        }
    }
}